import type { PcmpDivision } from '../types/pcmpQueue.types';

export const PCMP_QUEUE_PAGE_SIZE = 25;
export const PCMP_QUEUE_PAGE_SIZE_OPTIONS = [25, 50, 100] as const;

export const PCMP_DIVISION_LABELS = {
  CNS: 'CNS',
  CTG: 'Chattogram',
  RAJSHAHI: 'Rajshahi',
  MYMENSINGH: 'Mymensingh',
  DHAKA: 'Dhaka',
  KHULNA: 'Khulna',
} as const satisfies Record<PcmpDivision, string>;

export const PCMP_NOT_MAPPED_LABEL = 'Not Mapped';

/** A division's display name; "Not Mapped" for none or a code this client does not know. */
export function pcmpDivisionLabel(code: string | null | undefined): string {
  return code && code in PCMP_DIVISION_LABELS
    ? PCMP_DIVISION_LABELS[code as PcmpDivision]
    : PCMP_NOT_MAPPED_LABEL;
}

/** Statuses whose proposals carry a reason the queue can filter on. */
export const PCMP_REASON_STATUS = {
  MIS_NOT_VERIFIED: 'misReasons',
  ACCOUNTS_NOT_DISBURSED: 'accountsReasons',
} as const;

export const PCMP_QUEUE_FILTER_LIMITS = {
  refNo: 50,
  teacher: 100,
} as const;
